<template>
  <el-form
    :inline="true"
    :model="filter"
    class="demo-form-inline"
    size="mini"
    ref="filterForm"
  >
    <el-form-item
      v-for="(field, index) in filterSet.fields"
      :key="index"
      :label="field.label"
      :prop="field.key"
    >
      <el-input
        v-if="field.type == 'text'"
        v-model="filter[field.key]"
        :placeholder="field.placeholder"
      ></el-input>
      <el-select
        v-if="field.type == 'select'"
        v-model="filter[field.key]"
        :placeholder="field.placeholder"
      >
        <el-option
          v-for="item in field.options"
          v-bind:key="item[field.optionValue]"
          :label="item[field.optionName]"
          :value="item[field.optionValue]"
        ></el-option>
      </el-select>
      <el-date-picker
        style="width: 320px"
        v-if="field.type == 'date-picker'"
        v-model="filter[field.key]"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始时间"
        :clearable="false"
        end-placeholder="结束时间"
      ></el-date-picker>
    </el-form-item>
    <el-form-item style="display: block; text-align: center">
      <el-button type="primary" v-if="filterSet.showExport" @click="exportToExcel"
        >导出</el-button
      >
      <el-button type="primary" @click="searchAction">查 询</el-button>
      <el-button @click="$refs.filterForm.resetFields()">重 置</el-button>
      <el-button v-if="filterSet.showImport" @click="importFromExcel">导 入</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  name: "search-form",
  model: {
    prop: "filter",
    event: ["input", "change"],
  },
  props: {
    filterSet: {
      type: Object,
      default: () => {
        return {
            fields:[],
            showExport:false,
            showImport:false
        };
      },
    },
    filter: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created(){
      console.log(this.filterSet)
  },
  methods: {
    searchAction() {
      this.$emit("search");
    },
    exportToExcel() {
      this.$emit("export");
    },
    importFromExcel() {
      this.$emit("import");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/plugin/search-form.vue